import { Box } from "@mui/material";

export interface ContentProps {
  "data-testid"?: string;
}

const ContentBox: React.FC<React.PropsWithChildren<ContentProps>> = (props) => (
  <Box
  className="content-box"
  sx={{ 
    height: '100%', 
    width: '100%',
    backgroundColor: "white",
    padding: "30px 48px 30px 48px",
    borderRadius: "16px",
    border: "1px solid #ececec",
    boxShadow: "none",
     }}
    data-testid={props["data-testid"]}
  >
    {props.children}
  </Box>
);

export const ContentGridBox: React.FC<React.PropsWithChildren<ContentProps>> = (props) => (
  <Box
  className="content-grid-box"
  sx={{ 
    width: '100%',
    backgroundColor: "white",
    padding: "50px",
    borderRadius: "16px",
    border: "1px solid #ececec",
    boxShadow: "none",
     }}
    data-testid={props["data-testid"]}
  >
    {props.children}
  </Box>
);

/**
 * Detail-view DataGrid Premium tabs — 30px top, 50px right/bottom/left.
 * Upstream (gitlab/develop 50ce9aaa5 era) gives this box its own padding; the
 * 30px top is what `AeronetDataGridPremium`'s toolbar spacing is measured
 * against (PremiumListToolbar: 20px under + / ACTIONS). Was an alias of
 * ContentGridBox locally until the Premium pull-in (R55 hand reconcile).
 */
export const DetailPremiumBox: React.FC<
  React.PropsWithChildren<ContentProps>
> = (props) => (
  <Box
    className="detail-premium-box"
    sx={{
      height: "100%",
      width: "100%",
      backgroundColor: "white",
      padding: "30px 50px 50px 50px",
      borderRadius: "16px",
      border: "1px solid #ececec",
      boxShadow: "none",
    }}
    data-testid={props["data-testid"]}
  >
    {props.children}
  </Box>
);

export const HistoryGridBox: React.FC<React.PropsWithChildren<ContentProps>> = (props) => (
  <Box
  className="history-grid-box"
  sx={{ 
    width: '100%',
    backgroundColor: "white",
    padding:"15px 50px 50px 50px",
    borderRadius: "16px",
    border: "1px solid #ececec",
    boxShadow: "none",
     }}
    
  >
    {props.children}
  </Box>
);

export default ContentBox;
